<template>
  <div
    class="inline-flex items-center gap-2 bg-[#fff9ec] border border-primary rounded-[38px] px-3 py-2 md:px-4 md:py-2.5 w-fit"
  >
    <component
      :is="icon"
      v-if="icon"
      :size="iconSize"
      :class="iconClass"
      aria-hidden="true"
    />
    <span class="text-primary text-md font-semibold font-outfit leading-none">
      {{ title }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { Component } from "vue";

interface Props {
  title: string;
  icon?: Component;
  iconSize?: number;
  iconClass?: string;
}

withDefaults(defineProps<Props>(), {
  icon: undefined,
  iconSize: 20,
  iconClass: "text-primary",
});
</script>
